<template>
  <SearchSidebarGroup
    :label="label"
    :disabled="!terms.length"
    :count="activeCount"
  >
    <template v-for="term in termsSorted">
      <FacetColorTerm
        v-if="'color' in term && term.color"
        :key="term.key + 'color'"
        :facet-id="facetKey"
        :label="term.label || term.key"
        :count="term.count"
        :term-key="term.key"
        :color="term.color"
      />
      <FacetTerm
        v-else
        :key="term.key"
        :facet-id="facetKey"
        :label="term.label || term.key"
        :count="term.count"
        :term-key="term.key"
      />
    </template>
  </SearchSidebarGroup>
</template>

<script lang="ts" setup>
import type { ApiSearchFacetTerm } from '../../types'

const props = defineProps<{
  facetKey: string
  label: string
  terms: ApiSearchFacetTerm[]
}>()

const termsSorted = computed<ApiSearchFacetTerm[]>(() => {
  const terms = [...props.terms]
  return terms.sort((a, b) => {
    if (typeof a.weight === 'number' && typeof b.weight === 'number') {
      return a.weight > b.weight ? 1 : -1
    } else if (
      a.label &&
      parseFloat(a.label) &&
      b.label &&
      parseFloat(b.label)
    ) {
      return parseFloat(a.label) > parseFloat(b.label) ? 1 : -1
    } else {
      return a.label && b.label && a.label > b.label ? 1 : -1
    }
  })
})
const activeCount = computed(() => props.terms.filter((v) => v.active).length)
</script>
